<template>
    <div id="app">
        <Snack />
        <testSnackbar />
        <router-view />
        <preloader v-if="loading" />
    </div>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';
import preloader from './components/blocks/common/preloader';
import Snack from './components/blocks/Notifications/notifications_snack';
import testSnackbar from '@/components/view_blocks/Testing/test_snackbar/test_snackbar';

export default {
  components: {
    Snack,
    preloader,
    testSnackbar,
  },
  computed: {
    ...mapGetters('common', ['loading']),
    ...mapGetters('autorisation', [
      'user_id',
    ]),
  },
  watch: {
    user_id(id) {
      if (id) this.get_app_settings();
    },
  },
  async mounted() {
    let vm = this;

    window.onblur = function() {
      vm.SET_STATE_COMMON({key: 'pageFocus', value: false});
    };
    window.onfocus = function() {
      vm.SET_STATE_COMMON({key: 'pageFocus', value: true});
    };
  },
  methods: {
    ...mapMutations('autorisation', ['SET_USER_ID']),
    ...mapMutations('common', [
      'SET_STATE_COMMON',
    ]),
    ...mapActions('autorisation', [
      'get_app_settings',
    ]),
  },
};
</script>

<style lang="less" src='./less/style.less'></style>
